import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class DataTransferService implements DataTransfer {
  dropEffect: 'none' | 'copy' | 'link' | 'move' = 'none';
  effectAllowed:
    | 'none'
    | 'copy'
    | 'link'
    | 'move'
    | 'copyLink'
    | 'copyMove'
    | 'linkMove'
    | 'all'
    | 'uninitialized' = 'uninitialized';

  files: FileList;
  items: DataTransferItemList;
  types: readonly string[];

  private dataTransfer: DataTransfer = new DataTransfer();

  constructor() {
    this.files = this.dataTransfer.files;
    this.items = this.dataTransfer.items;
    this.types = this.dataTransfer.types;
  }

  clearData(format?: string): void {
    if (format) {
      this.dataTransfer.clearData(format);
    } else {
      this.dataTransfer.clearData();
    }
  }

  getData(format: string): string {
    this.dataTransfer.getData(format);

    return this.dataTransfer.getData(format);
  }

  setData(format: string, data: string): void {
    this.dataTransfer.setData(format, data);
  }

  setDragImage(image: Element, x: number, y: number): void {
    this.dataTransfer.setDragImage(image, x, y);
  }
}
